import { useNavigate } from 'react-router-dom';
import { Link as BaseLink } from '@carbon/react';

const Link = ({ href, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(href);
  };

  return <BaseLink {...props} href={href} onClick={handleClick} />;
};

export default Link;
